module.exports = __webpack_public_path__ + "static/img/5.54a3865d.png";